<style>
    .show {
        display: block !important;
    }
</style>

<template>
    <li class="m-nav__item m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width m-dropdown--skin-light m-list-search m-list-search--skin-light" m-dropdown-toggle="click" id="m_quicksearch" m-quicksearch-mode="dropdown" m-dropdown-persistent="1">
        <a href="#" class="m-nav__link m-dropdown__toggle">
                                                <span class="m-nav__link-icon">
                                                    <i class="flaticon-search-1"></i>
                                                </span>
        </a>
        <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--center"></span>
            <div class="m-dropdown__inner ">
                <div class="m-dropdown__header">
                    <form  class="m-list-search__form">
                        <div class="m-list-search__form-wrapper">
                                                                <span class="m-list-search__form-input-wrapper">
                                                                    <input v-model="quick_search" autocomplete="off" type="text" name="q" class="m-list-search__form-input" value="" :placeholder="$t('Search...')">
                                                                </span>
                            <span class="m-list-search__form-icon-close" id="m_quicksearch_close" @click="emptySearch">
                                                                    <i class="la la-remove"></i>
                                                                </span>
                        </div>
                    </form>
                </div>
                <div class="m-dropdown__body" v-bind:class="{'show': show}">
                    <div class="m-dropdown__scrollable m-scrollable" data-scrollable="true" data-max-height="300" data-mobile-max-height="200">
                        <div class="m-dropdown__content">
                            <span v-for="(item,index) in results" v-bind:key="index">
                                {{item.type}} <router-link :to="item.url">{{item.name}}</router-link><br/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
  name: 'HeaderSearch',
  data () {
    return {
      quick_search: null,
      show: false,
      results: []
    }
  },
  watch: {
    quick_search: {
      handler (val) {
        if (val !== '' && val !== undefined && val !== 'undefined') {
          this.setSearch()
        }
      },
      deep: true
    }
  },
  methods: {
    emptySearch () {
      this.quick_search = ''
      this.show = false
    },
    setSearch () {
      let self = this
      this.$http.get(process.env.API_URL + '/admin/search', {
        'params': {
          q: this.quick_search
        },
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language,
          'disableLoading': true
        }
      }).then(res => {
        self.show = true
        self.results = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/header/HeaderSearch.vue